/* ============================================================
   HUNDELEINEN.DE — Marken-Illustrationen (Brand-Art)
   ------------------------------------------------------------
   Signature-Elemente aus dem Brandbook als SVG-String-Helfer:
   Scallop-Rahmen, handgezeichnete Hundegesichter, Sticker,
   Line-Icons, Sterne, Siegel. currentColor-basiert → per CSS
   einfärbbar. Später als Liquid-Snippets portierbar.
   ============================================================ */
window.BP = (function(){
  const svg = (vb, inner, extra='') =>
    `<svg viewBox="${vb}" ${extra} xmlns="http://www.w3.org/2000/svg" style="display:block;width:100%;height:100%;overflow:visible">${inner}</svg>`;
  const strokeG = (w, paths, col='currentColor') =>
    `<g fill="none" stroke="${col}" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round">${
      paths.map(d=>`<path d="${d}"/>`).join('')}</g>`;

  /* ---------- Scallop-Rahmen ---------- */
  function scallopPath(cx,cy,rV,n){
    let d=''; const chord=2*rV*Math.sin(Math.PI/n); const r=(chord/2)*1.04;
    for(let i=0;i<=n;i++){ const a=(i/n)*2*Math.PI-Math.PI/2;
      const x=cx+rV*Math.cos(a), y=cy+rV*Math.sin(a);
      d += (i===0?`M${x.toFixed(1)} ${y.toFixed(1)}`:` A ${r.toFixed(1)} ${r.toFixed(1)} 0 0 1 ${x.toFixed(1)} ${y.toFixed(1)}`); }
    return d+' Z';
  }
  function scallop(rV=150,n=14){
    return svg('0 0 320 320', `<path d="${scallopPath(160,160,rV,n)}" fill="currentColor" stroke="#1B1714" stroke-width="5" stroke-linejoin="round"/>`);
  }

  /* ---------- Hundegesichter ---------- */
  const eye = (cx,cy,r=5.4)=>`<circle cx="${cx}" cy="${cy}" r="${r}" fill="currentColor"/>`;
  const nose = (cx,cy)=>`<path d="M${cx-8} ${cy} C${cx-8} ${cy-6} ${cx+8} ${cy-6} ${cx+8} ${cy} C${cx+8} ${cy+6} ${cx} ${cy+11} ${cx} ${cy+11} C${cx} ${cy+11} ${cx-8} ${cy+6} ${cx-8} ${cy} Z" fill="currentColor"/>`;
  const FACES = {
    floppy:{ w:6, p:[
      'M70 66 C44 62 32 90 42 124 C48 140 68 138 80 122',
      'M130 66 C156 62 168 90 158 124 C152 140 132 138 120 122',
      'M62 82 C58 50 78 34 100 34 C122 34 142 50 138 82 C136 106 122 122 100 122 C78 122 64 106 62 82 Z',
      'M80 106 C82 124 90 134 100 134 C110 134 118 124 120 106',
      'M100 122 C96 130 90 130 87 126 M100 122 C104 130 110 130 113 126'],
      extras:eye(84,92)+eye(116,92)+nose(100,110) },
    perky:{ w:6, p:[
      'M74 62 L60 22 L98 52','M126 62 L140 22 L102 52',
      'M66 92 C60 62 76 46 100 46 C124 46 140 62 134 92 C130 118 116 132 100 132 C84 132 70 118 66 92 Z',
      'M84 114 C86 128 94 136 100 136 C106 136 114 128 116 114',
      'M100 126 C96 132 90 132 88 129 M100 126 C104 132 110 132 112 129'],
      extras:eye(85,98,4.8)+eye(115,98,4.8)+nose(100,120) },
    poodle:{ w:6, p:[
      'M60 104 C44 100 42 76 60 72 C54 52 76 40 90 54 C98 38 122 38 130 54 C148 44 168 60 158 78 C176 82 172 106 154 106 C158 126 134 138 118 126 C110 138 90 138 82 126 C64 136 42 122 52 102 Z'],
      extras:'<path d="M74 90 C78 86 82 86 86 90 M126 90 C130 86 134 86 138 90" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>'+eye(88,102,5)+eye(120,102,5)+nose(104,120) }
  };
  function face(kind='floppy'){
    const f = FACES[kind]||FACES.floppy;
    return svg('0 0 200 200', strokeG(f.w, f.p)+f.extras);
  }

  /* ---------- Line-Icons (Produkt/Zubehör) ---------- */
  const ICONS = {
    Leine:['M22 16 a8 8 0 1 1 10 10 L44 46','M32 44 a6 6 0 1 0 12 0 v-7 a6 6 0 0 0 -12 0 z'],
    Halsband:['M12 26 C24 42 40 42 52 26','M12 26 C24 34 40 34 52 26','M30 42 v6 a4 4 0 0 0 8 0 v-6','M34 56 a4 4 0 1 0 0.1 0'],
    Karabiner:['M32 12 a5 5 0 0 1 0 10','M32 22 C22 24 20 42 30 50 C40 56 48 46 45 38','M45 38 l5 3 M45 38 l4 -4'],
    Knochen:['M18 24 a7 7 0 1 0 -1 8 L45 40 a7 7 0 1 0 3 -8 Z','M16 24 a5 5 0 1 0 0 8','M48 32 a5 5 0 1 0 0 -8'],
    Pfote:['M32 52 C22 52 18 44 20 38 C22 33 28 33 32 38 C36 33 42 33 44 38 C46 44 42 52 32 52 Z','M17 30 a4 5 0 1 0 0.1 0','M28 22 a4 5 0 1 0 0.1 0','M36 22 a4 5 0 1 0 0.1 0','M47 30 a4 5 0 1 0 0.1 0'],
    Ball:['M32 16 a16 16 0 1 0 0.1 0','M16 32 h32','M32 16 C22 24 22 40 32 48 M32 16 C42 24 42 40 32 48'],
    Anhaenger:['M20 14 h16 l12 12 v20 a4 4 0 0 1 -4 4 H20 a4 4 0 0 1 -4 -4 V18 a4 4 0 0 1 4 -4 Z','M36 14 v10 a2 2 0 0 0 2 2 h10','M24 40 h14'],
    Seil:['M12 30 l7 2 -5 4 6 2 -4 4','M52 30 l-7 2 5 4 -6 2 4 4','M20 32 C28 22 36 22 44 32 C36 42 28 42 20 32 Z','M28 30 v4 M36 30 v4'],
    Buerste:['M20 16 h24 a4 4 0 0 1 4 4 v10 a4 4 0 0 1 -4 4 H20 a4 4 0 0 1 -4 -4 V20 a4 4 0 0 1 4 -4 Z','M22 34 v10 M28 34 v12 M34 34 v10 M40 34 v12','M46 30 v14']
  };
  function icon(name,w=5){ return svg('0 0 64 64', strokeG(w, ICONS[name]||ICONS.Leine)); }
  function sticker(name){
    const p = ICONS[name]||ICONS.Knochen;
    return svg('0 0 64 64', strokeG(15, p, '#F7CE52')+strokeG(5, p, '#1B1714'));
  }
  function tile(name){ return `<div class="tile">${icon(name)}</div>`; }

  /* ---------- UI-Icons (klein) ---------- */
  const UI = {
    truck:['M2 8h16v14H2z','M18 12h6l4 4v6h-10z','M8 26a3 3 0 1 0 0-.1','M23 26a3 3 0 1 0 0-.1'],
    shield:['M16 3l11 4v7c0 8-5 13-11 15-6-2-11-7-11-15V7z','M11 15l4 4 7-8'],
    return:['M6 12a11 11 0 1 1-1 8','M6 6v6h6'],
    ring:['M16 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20z','M16 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z']
  };
  function uiIcon(name,col='currentColor',w=1.8){
    return svg('0 0 32 32', strokeG(w, UI[name]||UI.shield, col));
  }

  /* ---------- Sterne ---------- */
  function stars(rating=5,size=14){
    const r=Math.round(rating);
    let s='<span class="stars">';
    for(let i=0;i<5;i++) s+=`<span class="st${i<r?'':' off'}" style="font-size:${size}px">★</span>`;
    return s+'</span>';
  }

  /* ---------- Siegel / Badge ---------- */
  function badge(text='HUNDELEINEN.DE · FETTLEDER · ', ring='#F7CE52'){
    const id='arc'+Math.random().toString(36).slice(2,7);
    return `<svg viewBox="0 0 120 120" style="display:block;width:100%;height:100%">
      <defs><path id="${id}" d="M60 60 m-45 0 a45 45 0 1 1 90 0 a45 45 0 1 1 -90 0" fill="none"/></defs>
      <circle cx="60" cy="60" r="57" fill="none" stroke="${ring}" stroke-width="2.5"/>
      <circle cx="60" cy="60" r="47" fill="none" stroke="${ring}" stroke-width="1"/>
      <text font-family="Hanken Grotesk" font-weight="700" font-size="10" letter-spacing="1.8" fill="${ring}"><textPath href="#${id}" startOffset="0%">${text}</textPath></text>
      <g transform="translate(30,34) scale(0.24)" style="color:${ring}">${FACES.floppy.p.map(d=>`<path d="${d}" fill="none" stroke="${ring}" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>`).join('')}</g>
    </svg>`;
  }

  return { scallop, face, icon, sticker, tile, uiIcon, stars, badge };
})();
